import * as React from 'react';
import * as S from './styles';

const EmptySpecialHours: React.FC = (props) => {
  return (
    <S.Message>
      Add special hours here by hovering on this section and clicking on the 'Edit' button.
    </S.Message>
  )
}

export default EmptySpecialHours